var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imageFound)?_c('b-img',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.width,"alt":_vm.alt}}):_c('span',{staticClass:"icon-holder p-2 d-flex bg-light border rounded"},[_c('i',{class:['fa', _vm.fallback, 'fa-lg text-dark mt-auto']})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfc03be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/FallbackImage.vue
// module id = null
// module chunks = 